'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fetchCatalogLocationsIfNeeded = exports.areCatalogLocationsLoading = exports.getCatalogLocations = exports.LOAD_CATALOG_LOCATIONS_SUCCESS = exports.LOAD_CATALOG_LOCATIONS_REQUEST = exports.LOAD_CATALOG_LOCATIONS_FAIL = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _api = require('../api');

var _reselect = require('reselect');

var _config = require('./config');

var _ms = require('ms');

var _ms2 = _interopRequireDefault(_ms);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var LOAD_CATALOG_LOCATIONS_FAIL = exports.LOAD_CATALOG_LOCATIONS_FAIL = 'la/domain/catalogLocation/LOAD_FAIL';
var LOAD_CATALOG_LOCATIONS_REQUEST = exports.LOAD_CATALOG_LOCATIONS_REQUEST = 'la/domain/catalogLocation/LOAD_REQUEST';
var LOAD_CATALOG_LOCATIONS_SUCCESS = exports.LOAD_CATALOG_LOCATIONS_SUCCESS = 'la/domain/catalogLocation/LOAD_SUCCESS';

var REDUX_STORE_TIME = (0, _ms2.default)('30m');

/* reducer */
var DEFAULT_STATE = {
    loaded: 0,
    loading: false,
    locations: []
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case LOAD_CATALOG_LOCATIONS_FAIL:
            return (0, _extends3.default)({}, state, {
                loading: false
            });
        case LOAD_CATALOG_LOCATIONS_REQUEST:
            return (0, _extends3.default)({}, state, {
                loading: true
            });
        case LOAD_CATALOG_LOCATIONS_SUCCESS:
            return (0, _extends3.default)({}, state, {
                loaded: action.meta.actionTime,
                loading: false,
                locations: action.payload
            });
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.domain.catalogLocation;
};

var getCatalogLocations = exports.getCatalogLocations = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.locations;
});

var getLoadTimeForCatalogLocations = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.loaded;
});

var areCatalogLocationsLoading = exports.areCatalogLocationsLoading = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.loading;
});

var shouldFetchCatalogLocations = function shouldFetchCatalogLocations(state) {
    var item = getCatalogLocations(state);
    if (item) {
        var loaded = getLoadTimeForCatalogLocations(state);
        var time = Date.now();
        var diff = time - loaded;
        if (diff < REDUX_STORE_TIME) return false;
    }
    var loading = areCatalogLocationsLoading(state);
    return !loading;
};

/* ACTION CREATORS */
var loadCatalogLocations = function loadCatalogLocations() {
    return function (dispatch, getState) {
        var state = getState();
        var deployment = (0, _config.getDeployment)(state);
        dispatch({
            type: LOAD_CATALOG_LOCATIONS_REQUEST
        });
        return _api.CatalogLocation.fetchCatalogLocations({ deployment: deployment }).then(function (response) {
            dispatch({
                meta: { actionTime: Date.now() },
                payload: response.data,
                type: LOAD_CATALOG_LOCATIONS_SUCCESS
            });
        }).catch(function (error) {
            dispatch({
                error: true,
                payload: error,
                type: LOAD_CATALOG_LOCATIONS_FAIL
            });
        });
    };
};

var fetchCatalogLocationsIfNeeded = exports.fetchCatalogLocationsIfNeeded = function fetchCatalogLocationsIfNeeded() {
    return function (dispatch, getState) {
        if (shouldFetchCatalogLocations(getState())) {
            return dispatch(loadCatalogLocations());
        }
        return _promise2.default.resolve();
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/catalogLocation.js
// module id = oUvu
// module chunks = 60